const getItems = ( form, FilterResultWrapper, btn, isLoadMore ) => {

    form.append('nonce', svn_filter_args.nonce);
    form.append('type', 'getItems');

    if( isLoadMore ) {
        form.append('page', btn.getAttribute('data-page'));
    } else {
        btn.setAttribute('data-page', 1);
        btn.disabled = false;
    }
    

    fetch( `${ svn_filter_args.ajax_url }?action=${ svn_filter_args.action }` , {
        method: 'POST',
        headers: {
        },
        body: form
    })
    .then((response) => response.json())
    .then((data) => {

        if( isLoadMore ) {
            FilterResultWrapper.innerHTML = FilterResultWrapper.innerHTML + data.return.content;
            btn.setAttribute('data-page', data.return.page);
        } else {
            if( data.return.content ) {
                FilterResultWrapper.innerHTML = data.return.content;
            } else {
                FilterResultWrapper.innerHTML = `<p class="nothing-found">${svn_filter_args.nothing_found}</p>`;
            }
        }

        if( data.return.found === 0 ) {
            btn.disabled = true
        }
        if( data.return.is_last === true ) {
            btn.disabled = true
        }
        
    })
    .catch((error) => {
        console.error('Error:', error);
    });

}

export default getItems;